// СГЕНЕРИРОВАНО scripts/art/process.mjs (pnpm art:process) — не править руками.
// Растр символов и фонов слотов из design/art-raw → apps/web/public/art.

export type RasterSlot = 'garden' | 'deep' | 'spaceport' | 'sweet-shop' | 'workshop' | 'koi-pond';
export type RasterSymbolKey =
  | 'carrot'
  | 'tomato'
  | 'pumpkin'
  | 'radish'
  | 'corn'
  | 'can'
  | 'scarecrow'
  | 'sun'
  | 'shell'
  | 'starfish'
  | 'jelly'
  | 'fishA'
  | 'fishB'
  | 'fishC'
  | 'pearl'
  | 'bubble'
  | 'planetR'
  | 'planetB'
  | 'planetG'
  | 'planetO'
  | 'satellite'
  | 'astronaut'
  | 'ufo'
  | 'blackhole'
  | 'comet'
  | 'donut'
  | 'cupcake'
  | 'lollipop'
  | 'gummy'
  | 'macaron'
  | 'jar'
  | 'jar_mini'
  | 'jar_major'
  | 'jar_grand'
  | 'gear'
  | 'wrench'
  | 'bulb'
  | 'blueprint'
  | 'robot'
  | 'part'
  | 'battery'
  | 'hammer'
  | 'koi'
  | 'moonBridge'
  | 'lotus'
  | 'lantern'
  | 'mandarin'
  | 'fan'
  | 'bamboo'
  | 'jadeCoin'
  | 'rank10'
  | 'rank9'
  | 'rank8';
export type RasterBackgroundKey = 'reels-dark' | 'reels-light' | 'scene-dark' | 'scene-light';

/** Пара путей: 1x и @2x (если @2x нет — тот же 1x). */
export interface RasterImage {
  readonly x1: string;
  readonly x2: string;
}

export interface RasterAtlas extends RasterImage {
  readonly cell: number;
  readonly width: number;
  readonly height: number;
  /** координаты в 1x; для @2x умножать на 2 */
  readonly frames: Readonly<Record<string, { x: number; y: number; w: number; h: number }>>;
}

export const RASTER_SYMBOLS: Partial<Record<RasterSlot, Partial<Record<RasterSymbolKey, RasterImage>>>> = {
  garden: {
    carrot: {
      x1: '/art/garden/carrot.webp?v=c93df2ba',
      x2: '/art/garden/carrot@2x.webp?v=2e96233a',
    },
    tomato: {
      x1: '/art/garden/tomato.webp?v=b92a09e7',
      x2: '/art/garden/tomato@2x.webp?v=cba1b719',
    },
    pumpkin: {
      x1: '/art/garden/pumpkin.webp?v=0a94bf46',
      x2: '/art/garden/pumpkin@2x.webp?v=052402d5',
    },
    radish: {
      x1: '/art/garden/radish.webp?v=87f80112',
      x2: '/art/garden/radish@2x.webp?v=e11c7a3b',
    },
    corn: {
      x1: '/art/garden/corn.webp?v=4aa9107c',
      x2: '/art/garden/corn@2x.webp?v=7c6c2f29',
    },
    can: {
      x1: '/art/garden/can.webp?v=13bb6846',
      x2: '/art/garden/can@2x.webp?v=63fdb57c',
    },
    scarecrow: {
      x1: '/art/garden/scarecrow.webp?v=214eeb43',
      x2: '/art/garden/scarecrow@2x.webp?v=0640d88d',
    },
    sun: {
      x1: '/art/garden/sun.webp?v=ee5a33fb',
      x2: '/art/garden/sun@2x.webp?v=435b3db4',
    },
  },
  deep: {
    shell: {
      x1: '/art/deep/shell.webp?v=ff9d83ce',
      x2: '/art/deep/shell@2x.webp?v=be47bd9e',
    },
    starfish: {
      x1: '/art/deep/starfish.webp?v=51e752dc',
      x2: '/art/deep/starfish@2x.webp?v=b9964584',
    },
    jelly: {
      x1: '/art/deep/jelly.webp?v=0253293e',
      x2: '/art/deep/jelly@2x.webp?v=e5c478ad',
    },
    fishA: {
      x1: '/art/deep/fishA.webp?v=cb40a5fe',
      x2: '/art/deep/fishA@2x.webp?v=c6ff32ba',
    },
    fishB: {
      x1: '/art/deep/fishB.webp?v=8bbc5ca0',
      x2: '/art/deep/fishB@2x.webp?v=dbd0b5c3',
    },
    fishC: {
      x1: '/art/deep/fishC.webp?v=0a8bae15',
      x2: '/art/deep/fishC@2x.webp?v=3b1a47e8',
    },
    pearl: {
      x1: '/art/deep/pearl.webp?v=3855fed2',
      x2: '/art/deep/pearl@2x.webp?v=df423d7a',
    },
    bubble: {
      x1: '/art/deep/bubble.webp?v=90ed796c',
      x2: '/art/deep/bubble@2x.webp?v=de453f67',
    },
  },
  spaceport: {
    planetR: {
      x1: '/art/spaceport/planetR.webp?v=6f2af10b',
      x2: '/art/spaceport/planetR@2x.webp?v=57f47e9f',
    },
    planetB: {
      x1: '/art/spaceport/planetB.webp?v=a079323c',
      x2: '/art/spaceport/planetB@2x.webp?v=1988d935',
    },
    planetG: {
      x1: '/art/spaceport/planetG.webp?v=084dc33f',
      x2: '/art/spaceport/planetG@2x.webp?v=b5df9c14',
    },
    planetO: {
      x1: '/art/spaceport/planetO.webp?v=3e839417',
      x2: '/art/spaceport/planetO@2x.webp?v=0689daa4',
    },
    satellite: {
      x1: '/art/spaceport/satellite.webp?v=7fac050a',
      x2: '/art/spaceport/satellite@2x.webp?v=b8cf6c75',
    },
    astronaut: {
      x1: '/art/spaceport/astronaut.webp?v=bd6a2a39',
      x2: '/art/spaceport/astronaut@2x.webp?v=ed1bafda',
    },
    ufo: {
      x1: '/art/spaceport/ufo.webp?v=6a9b9734',
      x2: '/art/spaceport/ufo@2x.webp?v=c68f1959',
    },
    blackhole: {
      x1: '/art/spaceport/blackhole.webp?v=25c3f27f',
      x2: '/art/spaceport/blackhole@2x.webp?v=f3ab6b67',
    },
    comet: {
      x1: '/art/spaceport/comet.webp?v=5cc908bf',
      x2: '/art/spaceport/comet@2x.webp?v=3d885f87',
    },
  },
  'sweet-shop': {
    donut: {
      x1: '/art/sweet-shop/donut.webp?v=770db9e9',
      x2: '/art/sweet-shop/donut@2x.webp?v=49bbc26b',
    },
    cupcake: {
      x1: '/art/sweet-shop/cupcake.webp?v=6190d513',
      x2: '/art/sweet-shop/cupcake@2x.webp?v=8aee3e35',
    },
    lollipop: {
      x1: '/art/sweet-shop/lollipop.webp?v=c6a72d1b',
      x2: '/art/sweet-shop/lollipop@2x.webp?v=37106e1f',
    },
    gummy: {
      x1: '/art/sweet-shop/gummy.webp?v=43bffb5b',
      x2: '/art/sweet-shop/gummy@2x.webp?v=7a714717',
    },
    macaron: {
      x1: '/art/sweet-shop/macaron.webp?v=615f9fe6',
      x2: '/art/sweet-shop/macaron@2x.webp?v=942526da',
    },
    jar: {
      x1: '/art/sweet-shop/jar.webp?v=b61c60c7',
      x2: '/art/sweet-shop/jar@2x.webp?v=a9faae77',
    },
    jar_mini: {
      x1: '/art/sweet-shop/jar_mini.webp?v=db3c0c2c',
      x2: '/art/sweet-shop/jar_mini@2x.webp?v=0a73fe03',
    },
    jar_major: {
      x1: '/art/sweet-shop/jar_major.webp?v=f8219775',
      x2: '/art/sweet-shop/jar_major@2x.webp?v=412e4c24',
    },
    jar_grand: {
      x1: '/art/sweet-shop/jar_grand.webp?v=0ee191d4',
      x2: '/art/sweet-shop/jar_grand@2x.webp?v=b7646ed5',
    },
  },
  workshop: {
    gear: {
      x1: '/art/workshop/gear.webp?v=645ca517',
      x2: '/art/workshop/gear@2x.webp?v=0f8d3e5f',
    },
    wrench: {
      x1: '/art/workshop/wrench.webp?v=7fb00bea',
      x2: '/art/workshop/wrench@2x.webp?v=a0cadee8',
    },
    bulb: {
      x1: '/art/workshop/bulb.webp?v=86450dbd',
      x2: '/art/workshop/bulb@2x.webp?v=c76e4419',
    },
    blueprint: {
      x1: '/art/workshop/blueprint.webp?v=34a506ae',
      x2: '/art/workshop/blueprint@2x.webp?v=71a0f12f',
    },
    robot: {
      x1: '/art/workshop/robot.webp?v=21f98b27',
      x2: '/art/workshop/robot@2x.webp?v=2b957e37',
    },
    part: {
      x1: '/art/workshop/part.webp?v=05ad9dde',
      x2: '/art/workshop/part@2x.webp?v=52330f84',
    },
    battery: {
      x1: '/art/workshop/battery.webp?v=b2b07d50',
      x2: '/art/workshop/battery@2x.webp?v=5da1d009',
    },
    hammer: {
      x1: '/art/workshop/hammer.webp?v=757b2750',
      x2: '/art/workshop/hammer@2x.webp?v=e0ce6cc1',
    },
  },
  'koi-pond': {
    koi: {
      x1: '/art/koi-pond/koi.webp?v=cadfb5b2',
      x2: '/art/koi-pond/koi@2x.webp?v=31756db0',
    },
    moonBridge: {
      x1: '/art/koi-pond/moonBridge.webp?v=f45505ac',
      x2: '/art/koi-pond/moonBridge@2x.webp?v=4a2deed7',
    },
    lotus: {
      x1: '/art/koi-pond/lotus.webp?v=ae60698d',
      x2: '/art/koi-pond/lotus@2x.webp?v=7c39e202',
    },
    lantern: {
      x1: '/art/koi-pond/lantern.webp?v=fcc0ad28',
      x2: '/art/koi-pond/lantern@2x.webp?v=888b5ae2',
    },
    mandarin: {
      x1: '/art/koi-pond/mandarin.webp?v=3ab8178d',
      x2: '/art/koi-pond/mandarin@2x.webp?v=ec6b1ad4',
    },
    fan: {
      x1: '/art/koi-pond/fan.webp?v=e1d36e6f',
      x2: '/art/koi-pond/fan@2x.webp?v=b13f8ff0',
    },
    bamboo: {
      x1: '/art/koi-pond/bamboo.webp?v=480d42d9',
      x2: '/art/koi-pond/bamboo@2x.webp?v=cc19704a',
    },
    jadeCoin: {
      x1: '/art/koi-pond/jadeCoin.webp?v=f72bbd67',
      x2: '/art/koi-pond/jadeCoin@2x.webp?v=700eb980',
    },
  },
};

export const RASTER_BACKGROUNDS: Partial<
  Record<RasterSlot, Partial<Record<RasterBackgroundKey, RasterImage>>>
> = {
  garden: {
    'reels-dark': {
      x1: '/art/garden/reels-dark.webp?v=fd13ecf2',
      x2: '/art/garden/reels-dark@2x.webp?v=1da2f0a1',
    },
    'reels-light': {
      x1: '/art/garden/reels-light.webp?v=d0633765',
      x2: '/art/garden/reels-light@2x.webp?v=4c01687d',
    },
    'scene-dark': {
      x1: '/art/garden/scene-dark.webp?v=f706f4e2',
      x2: '/art/garden/scene-dark@2x.webp?v=2dd388f0',
    },
    'scene-light': {
      x1: '/art/garden/scene-light.webp?v=946696fd',
      x2: '/art/garden/scene-light@2x.webp?v=5c662c7e',
    },
  },
  deep: {
    'reels-dark': {
      x1: '/art/deep/reels-dark.webp?v=8082b3ac',
      x2: '/art/deep/reels-dark@2x.webp?v=2915b760',
    },
    'reels-light': {
      x1: '/art/deep/reels-light.webp?v=b1901bb0',
      x2: '/art/deep/reels-light@2x.webp?v=c8aca728',
    },
    'scene-dark': {
      x1: '/art/deep/scene-dark.webp?v=34d45099',
      x2: '/art/deep/scene-dark@2x.webp?v=3d5b9da0',
    },
    'scene-light': {
      x1: '/art/deep/scene-light.webp?v=e6a6ec39',
      x2: '/art/deep/scene-light@2x.webp?v=cd6a4a44',
    },
  },
  spaceport: {
    'reels-dark': {
      x1: '/art/spaceport/reels-dark.webp?v=37ef28aa',
      x2: '/art/spaceport/reels-dark@2x.webp?v=aef4d291',
    },
    'reels-light': {
      x1: '/art/spaceport/reels-light.webp?v=cfe741b9',
      x2: '/art/spaceport/reels-light@2x.webp?v=2f02ad67',
    },
    'scene-dark': {
      x1: '/art/spaceport/scene-dark.webp?v=27b28e21',
      x2: '/art/spaceport/scene-dark@2x.webp?v=57b6f516',
    },
    'scene-light': {
      x1: '/art/spaceport/scene-light.webp?v=5edab310',
      x2: '/art/spaceport/scene-light@2x.webp?v=214150d7',
    },
  },
  'sweet-shop': {
    'reels-dark': {
      x1: '/art/sweet-shop/reels-dark.webp?v=33d639ab',
      x2: '/art/sweet-shop/reels-dark@2x.webp?v=be9e764a',
    },
    'reels-light': {
      x1: '/art/sweet-shop/reels-light.webp?v=d672a8d4',
      x2: '/art/sweet-shop/reels-light@2x.webp?v=fc982a51',
    },
    'scene-dark': {
      x1: '/art/sweet-shop/scene-dark.webp?v=0d67633e',
      x2: '/art/sweet-shop/scene-dark@2x.webp?v=e5ed6953',
    },
    'scene-light': {
      x1: '/art/sweet-shop/scene-light.webp?v=7c7a3d57',
      x2: '/art/sweet-shop/scene-light@2x.webp?v=d806163c',
    },
  },
  workshop: {
    'reels-dark': {
      x1: '/art/workshop/reels-dark.webp?v=f065a006',
      x2: '/art/workshop/reels-dark@2x.webp?v=28a57aed',
    },
    'reels-light': {
      x1: '/art/workshop/reels-light.webp?v=659ce9a5',
      x2: '/art/workshop/reels-light@2x.webp?v=18b70964',
    },
    'scene-dark': {
      x1: '/art/workshop/scene-dark.webp?v=79ee2138',
      x2: '/art/workshop/scene-dark@2x.webp?v=42032ea7',
    },
    'scene-light': {
      x1: '/art/workshop/scene-light.webp?v=c59d1772',
      x2: '/art/workshop/scene-light@2x.webp?v=500d2b37',
    },
  },
  'koi-pond': {
    'reels-dark': {
      x1: '/art/koi-pond/reels-dark.webp?v=46977b30',
      x2: '/art/koi-pond/reels-dark@2x.webp?v=946186f2',
    },
    'reels-light': {
      x1: '/art/koi-pond/reels-light.webp?v=6a8475d7',
      x2: '/art/koi-pond/reels-light@2x.webp?v=783d667b',
    },
    'scene-dark': {
      x1: '/art/koi-pond/scene-dark.webp?v=d437d0d7',
      x2: '/art/koi-pond/scene-dark@2x.webp?v=f3851f02',
    },
    'scene-light': {
      x1: '/art/koi-pond/scene-light.webp?v=c74c46b5',
      x2: '/art/koi-pond/scene-light@2x.webp?v=2cb300f6',
    },
  },
};

export const RASTER_ATLASES: Partial<Record<RasterSlot, RasterAtlas>> = {
  garden: {
    x1: '/art/garden/atlas.webp?v=05c09c0e',
    x2: '/art/garden/atlas@2x.webp?v=4d77c155',
    cell: 256,
    width: 768,
    height: 768,
    frames: {
      carrot: {
        x: 0,
        y: 0,
        w: 256,
        h: 256,
      },
      tomato: {
        x: 256,
        y: 0,
        w: 256,
        h: 256,
      },
      pumpkin: {
        x: 512,
        y: 0,
        w: 256,
        h: 256,
      },
      radish: {
        x: 0,
        y: 256,
        w: 256,
        h: 256,
      },
      corn: {
        x: 256,
        y: 256,
        w: 256,
        h: 256,
      },
      can: {
        x: 512,
        y: 256,
        w: 256,
        h: 256,
      },
      scarecrow: {
        x: 0,
        y: 512,
        w: 256,
        h: 256,
      },
      sun: {
        x: 256,
        y: 512,
        w: 256,
        h: 256,
      },
    },
  },
  deep: {
    x1: '/art/deep/atlas.webp?v=38a6c077',
    x2: '/art/deep/atlas@2x.webp?v=f37b6fc7',
    cell: 256,
    width: 768,
    height: 768,
    frames: {
      shell: {
        x: 0,
        y: 0,
        w: 256,
        h: 256,
      },
      starfish: {
        x: 256,
        y: 0,
        w: 256,
        h: 256,
      },
      jelly: {
        x: 512,
        y: 0,
        w: 256,
        h: 256,
      },
      fishA: {
        x: 0,
        y: 256,
        w: 256,
        h: 256,
      },
      fishB: {
        x: 256,
        y: 256,
        w: 256,
        h: 256,
      },
      fishC: {
        x: 512,
        y: 256,
        w: 256,
        h: 256,
      },
      pearl: {
        x: 0,
        y: 512,
        w: 256,
        h: 256,
      },
      bubble: {
        x: 256,
        y: 512,
        w: 256,
        h: 256,
      },
    },
  },
  spaceport: {
    x1: '/art/spaceport/atlas.webp?v=a30e5c15',
    x2: '/art/spaceport/atlas@2x.webp?v=2b6f4dc9',
    cell: 256,
    width: 768,
    height: 768,
    frames: {
      planetR: {
        x: 0,
        y: 0,
        w: 256,
        h: 256,
      },
      planetB: {
        x: 256,
        y: 0,
        w: 256,
        h: 256,
      },
      planetG: {
        x: 512,
        y: 0,
        w: 256,
        h: 256,
      },
      planetO: {
        x: 0,
        y: 256,
        w: 256,
        h: 256,
      },
      satellite: {
        x: 256,
        y: 256,
        w: 256,
        h: 256,
      },
      astronaut: {
        x: 512,
        y: 256,
        w: 256,
        h: 256,
      },
      ufo: {
        x: 0,
        y: 512,
        w: 256,
        h: 256,
      },
      blackhole: {
        x: 256,
        y: 512,
        w: 256,
        h: 256,
      },
      comet: {
        x: 512,
        y: 512,
        w: 256,
        h: 256,
      },
    },
  },
  'sweet-shop': {
    x1: '/art/sweet-shop/atlas.webp?v=9366a211',
    x2: '/art/sweet-shop/atlas@2x.webp?v=b758ffad',
    cell: 256,
    width: 768,
    height: 768,
    frames: {
      donut: {
        x: 0,
        y: 0,
        w: 256,
        h: 256,
      },
      cupcake: {
        x: 256,
        y: 0,
        w: 256,
        h: 256,
      },
      lollipop: {
        x: 512,
        y: 0,
        w: 256,
        h: 256,
      },
      gummy: {
        x: 0,
        y: 256,
        w: 256,
        h: 256,
      },
      macaron: {
        x: 256,
        y: 256,
        w: 256,
        h: 256,
      },
      jar: {
        x: 512,
        y: 256,
        w: 256,
        h: 256,
      },
      jar_mini: {
        x: 0,
        y: 512,
        w: 256,
        h: 256,
      },
      jar_major: {
        x: 256,
        y: 512,
        w: 256,
        h: 256,
      },
      jar_grand: {
        x: 512,
        y: 512,
        w: 256,
        h: 256,
      },
    },
  },
  workshop: {
    x1: '/art/workshop/atlas.webp?v=2bf3dfe5',
    x2: '/art/workshop/atlas@2x.webp?v=3b7bdf2a',
    cell: 256,
    width: 768,
    height: 768,
    frames: {
      gear: {
        x: 0,
        y: 0,
        w: 256,
        h: 256,
      },
      wrench: {
        x: 256,
        y: 0,
        w: 256,
        h: 256,
      },
      bulb: {
        x: 512,
        y: 0,
        w: 256,
        h: 256,
      },
      blueprint: {
        x: 0,
        y: 256,
        w: 256,
        h: 256,
      },
      robot: {
        x: 256,
        y: 256,
        w: 256,
        h: 256,
      },
      part: {
        x: 512,
        y: 256,
        w: 256,
        h: 256,
      },
      battery: {
        x: 0,
        y: 512,
        w: 256,
        h: 256,
      },
      hammer: {
        x: 256,
        y: 512,
        w: 256,
        h: 256,
      },
    },
  },
  'koi-pond': {
    x1: '/art/koi-pond/atlas.webp?v=b3b5956a',
    x2: '/art/koi-pond/atlas@2x.webp?v=7846c4f2',
    cell: 256,
    width: 768,
    height: 768,
    frames: {
      koi: {
        x: 0,
        y: 0,
        w: 256,
        h: 256,
      },
      moonBridge: {
        x: 256,
        y: 0,
        w: 256,
        h: 256,
      },
      lotus: {
        x: 512,
        y: 0,
        w: 256,
        h: 256,
      },
      lantern: {
        x: 0,
        y: 256,
        w: 256,
        h: 256,
      },
      mandarin: {
        x: 256,
        y: 256,
        w: 256,
        h: 256,
      },
      fan: {
        x: 512,
        y: 256,
        w: 256,
        h: 256,
      },
      bamboo: {
        x: 0,
        y: 512,
        w: 256,
        h: 256,
      },
      jadeCoin: {
        x: 256,
        y: 512,
        w: 256,
        h: 256,
      },
    },
  },
};

// ── other games: lobby covers, objects, icons (one edition for both themes) and themed backgrounds ──

export type RasterGroup =
  | 'covers'
  | 'crash'
  | 'pot'
  | 'roulette'
  | 'carp'
  | 'firecrackers'
  | 'hongbao'
  | 'mahjong'
  | 'mahjong-table'
  | 'tile-match'
  | 'chess'
  | 'daily-words'
  | 'color-sort'
  | 'lucky-lever'
  | 'neon-arcade'
  | 'pirate-cove'
  | 'zhajinhua'
  | 'doudizhu'
  | 'cards'
  | 'koi-ranks'
  | 'icons'
  | 'passport'
  | 'emblems'
  | 'ui';
export type RasterTheme = 'dark' | 'light';

/** Keys of RASTER_ART per group (objects + covers). */
export interface RasterArtKeys {
  covers:
    | 'crash'
    | 'pot'
    | 'roulette'
    | 'garden'
    | 'deep'
    | 'spaceport'
    | 'sweet-shop'
    | 'workshop'
    | 'koi-pond'
    | 'lucky-lever'
    | 'neon-arcade'
    | 'pirate-cove'
    | 'carp'
    | 'firecrackers'
    | 'hongbao'
    | 'mahjong'
    | 'mahjong-table'
    | 'zhajinhua'
    | 'doudizhu'
    | 'tile-match'
    | 'color-sort'
    | 'chess'
    | 'daily-words'
    | 'crash-hero';
  crash: 'rocket' | 'rocket-crashed';
  pot: 'pointer' | 'ring' | 'hub-dark' | 'hub-light' | 'wheel-empty';
  roulette: 'pointer' | 'tile-red' | 'tile-black' | 'tile-green';
  carp: 'carp' | 'dragon' | 'gate' | 'ledge' | 'ledge-broken' | 'rock';
  firecrackers: 'envelope' | 'open' | 'ingot' | 'firecracker' | 'sparks';
  hongbao: 'seat' | 'crown' | 'envelope';
  mahjong: 'tile-back' | 'tile-face';
  'mahjong-table': never;
  'tile-match': never;
  chess:
    | 'classic-wK'
    | 'classic-wQ'
    | 'classic-wR'
    | 'classic-wB'
    | 'classic-wN'
    | 'classic-wp'
    | 'classic-bK'
    | 'classic-bQ'
    | 'classic-bR'
    | 'classic-bB'
    | 'classic-bN'
    | 'classic-bp'
    | 'modern-wK'
    | 'modern-wQ'
    | 'modern-wR'
    | 'modern-wB'
    | 'modern-wN'
    | 'modern-wp'
    | 'modern-bK'
    | 'modern-bQ'
    | 'modern-bR'
    | 'modern-bB'
    | 'modern-bN'
    | 'modern-bp';
  'daily-words': never;
  'color-sort':
    'chip-0' | 'chip-1' | 'chip-2' | 'chip-3' | 'chip-4' | 'chip-5' | 'chip-6' | 'chip-7' | 'tube';
  'lucky-lever':
    'peach' | 'gourd' | 'lantern' | 'koi' | 'ingot' | 'jade' | 'dragon' | 'lever-arm' | 'lever-knob';
  'neon-arcade':
    'star' | 'flipper' | 'cassette' | 'joystick' | 'crystal' | 'ufo' | 'bolt' | 'lever-arm' | 'lever-knob';
  'pirate-cove':
    'shell' | 'anchor' | 'spyglass' | 'compass' | 'parrot' | 'map' | 'chest' | 'lever-arm' | 'lever-knob';
  zhajinhua: never;
  doudizhu: never;
  cards: 'card-back' | 'deck' | 'landlord-hat' | 'flower-emblem';
  'koi-ranks': 'disc-teal' | 'disc-sky' | 'disc-purple';
  icons:
    | 'home'
    | 'messages'
    | 'machines'
    | 'games'
    | 'slots'
    | 'tournaments'
    | 'friends'
    | 'profile'
    | 'settings'
    | 'sound-on'
    | 'sound-off'
    | 'music-on'
    | 'music-off'
    | 'info'
    | 'paytable'
    | 'autoplay'
    | 'back'
    | 'close'
    | 'plus'
    | 'minus'
    | 'share'
    | 'history'
    | 'fair-shield'
    | 'limits'
    | 'gift'
    | 'trophy'
    | 'bell'
    | 'search'
    | 'logout'
    | 'language'
    | 'theme'
    | 'coin'
    | 'puzzles'
    | 'friends-small'
    | 'profile-small'
    | 'games-small'
    | 'autoplay-small'
    | 'history-small'
    | 'logout-small'
    | 'theme-small'
    | 'messages-small'
    | 'machines-small';
  passport: 'stamp';
  emblems: 'quest' | 'jackpot';
  ui: never;
}

/** Bases of RASTER_BG per group (files <base>-dark / <base>-light). */
export interface RasterBgKeys {
  crash: 'sky' | 'scene';
  pot: 'stage' | 'scene';
  roulette: 'stage' | 'scene';
  carp: 'fall' | 'scene';
  firecrackers: 'board' | 'scene';
  hongbao: 'table' | 'scene';
  mahjong: 'felt' | 'scene';
  'mahjong-table': 'scene';
  'tile-match': 'scene';
  chess: 'scene';
  'daily-words': 'scene';
  'color-sort': 'scene';
  'lucky-lever': 'cabinet' | 'scene';
  'neon-arcade': 'cabinet' | 'scene';
  'pirate-cove': 'cabinet' | 'scene';
  zhajinhua: 'scene';
  doudizhu: 'scene';
  cards: 'table';
  passport: 'cover';
  ui:
    | 'reels-frame-garden'
    | 'reels-frame-deep'
    | 'reels-frame-spaceport'
    | 'reels-frame-sweet-shop'
    | 'reels-frame-workshop'
    | 'reels-frame-koi-pond'
    | 'jackpot-plate-mini'
    | 'jackpot-plate-major'
    | 'jackpot-plate-grand'
    | 'win-plate'
    | 'badge-hot'
    | 'badge-new';
}

export const RASTER_ART: {
  readonly [G in RasterGroup]?: Partial<Record<RasterArtKeys[G], RasterImage>>;
} = {
  covers: {
    crash: {
      x1: '/art/covers/crash.webp?v=a702ed92',
      x2: '/art/covers/crash@2x.webp?v=48b2a3f9',
    },
    pot: {
      x1: '/art/covers/pot.webp?v=e09fc99a',
      x2: '/art/covers/pot@2x.webp?v=e9dd540b',
    },
    roulette: {
      x1: '/art/covers/roulette.webp?v=0b107a47',
      x2: '/art/covers/roulette@2x.webp?v=4abbd738',
    },
    garden: {
      x1: '/art/covers/garden.webp?v=2cea8a2c',
      x2: '/art/covers/garden@2x.webp?v=9614b8fe',
    },
    deep: {
      x1: '/art/covers/deep.webp?v=a67cb1ac',
      x2: '/art/covers/deep@2x.webp?v=9aee96be',
    },
    spaceport: {
      x1: '/art/covers/spaceport.webp?v=128891d5',
      x2: '/art/covers/spaceport@2x.webp?v=2f406969',
    },
    'sweet-shop': {
      x1: '/art/covers/sweet-shop.webp?v=9fed065a',
      x2: '/art/covers/sweet-shop@2x.webp?v=af80637e',
    },
    workshop: {
      x1: '/art/covers/workshop.webp?v=880cb88e',
      x2: '/art/covers/workshop@2x.webp?v=04bdca27',
    },
    'koi-pond': {
      x1: '/art/covers/koi-pond.webp?v=63d159b9',
      x2: '/art/covers/koi-pond@2x.webp?v=ed1225ca',
    },
    'lucky-lever': {
      x1: '/art/covers/lucky-lever.webp?v=f58b9c40',
      x2: '/art/covers/lucky-lever@2x.webp?v=596899bc',
    },
    'neon-arcade': {
      x1: '/art/covers/neon-arcade.webp?v=68fe7f19',
      x2: '/art/covers/neon-arcade@2x.webp?v=7ccd4365',
    },
    'pirate-cove': {
      x1: '/art/covers/pirate-cove.webp?v=a250c8c0',
      x2: '/art/covers/pirate-cove@2x.webp?v=512306c9',
    },
    carp: {
      x1: '/art/covers/carp.webp?v=62c375b9',
      x2: '/art/covers/carp@2x.webp?v=9da83e8c',
    },
    firecrackers: {
      x1: '/art/covers/firecrackers.webp?v=b33d32bd',
      x2: '/art/covers/firecrackers@2x.webp?v=9319cb63',
    },
    hongbao: {
      x1: '/art/covers/hongbao.webp?v=8b35999e',
      x2: '/art/covers/hongbao@2x.webp?v=cf7800b5',
    },
    mahjong: {
      x1: '/art/covers/mahjong.webp?v=77377394',
      x2: '/art/covers/mahjong@2x.webp?v=d9c6557f',
    },
    'mahjong-table': {
      x1: '/art/covers/mahjong-table.webp?v=b41892a9',
      x2: '/art/covers/mahjong-table@2x.webp?v=07f56157',
    },
    zhajinhua: {
      x1: '/art/covers/zhajinhua.webp?v=5bdb1114',
      x2: '/art/covers/zhajinhua@2x.webp?v=8573eafb',
    },
    doudizhu: {
      x1: '/art/covers/doudizhu.webp?v=81b9a0af',
      x2: '/art/covers/doudizhu@2x.webp?v=36e4ac0f',
    },
    'tile-match': {
      x1: '/art/covers/tile-match.webp?v=0d5c4267',
      x2: '/art/covers/tile-match@2x.webp?v=b3481bc7',
    },
    'color-sort': {
      x1: '/art/covers/color-sort.webp?v=65de8149',
      x2: '/art/covers/color-sort@2x.webp?v=e0fd4a2a',
    },
    chess: {
      x1: '/art/covers/chess.webp?v=3c086f33',
      x2: '/art/covers/chess@2x.webp?v=d3abb710',
    },
    'daily-words': {
      x1: '/art/covers/daily-words.webp?v=1f6c4edf',
      x2: '/art/covers/daily-words@2x.webp?v=bb424ff0',
    },
    'crash-hero': {
      x1: '/art/covers/crash-hero.webp?v=6785e513',
      x2: '/art/covers/crash-hero@2x.webp?v=27955202',
    },
  },
  crash: {
    rocket: {
      x1: '/art/crash/rocket.webp?v=31dd4256',
      x2: '/art/crash/rocket@2x.webp?v=b97a882d',
    },
    'rocket-crashed': {
      x1: '/art/crash/rocket-crashed.webp?v=000dce35',
      x2: '/art/crash/rocket-crashed@2x.webp?v=effcaf41',
    },
  },
  pot: {
    pointer: {
      x1: '/art/pot/pointer.webp?v=ca4528e6',
      x2: '/art/pot/pointer@2x.webp?v=c286ff4a',
    },
    ring: {
      x1: '/art/pot/ring.webp?v=1b3329de',
      x2: '/art/pot/ring@2x.webp?v=615b013c',
    },
    'hub-dark': {
      x1: '/art/pot/hub-dark.webp?v=33349c00',
      x2: '/art/pot/hub-dark@2x.webp?v=bb8c6cf2',
    },
    'hub-light': {
      x1: '/art/pot/hub-light.webp?v=cec72eeb',
      x2: '/art/pot/hub-light@2x.webp?v=4a33b54a',
    },
    'wheel-empty': {
      x1: '/art/pot/wheel-empty.webp?v=dc6bb78f',
      x2: '/art/pot/wheel-empty@2x.webp?v=588c642d',
    },
  },
  roulette: {
    pointer: {
      x1: '/art/roulette/pointer.webp?v=f9b811a4',
      x2: '/art/roulette/pointer@2x.webp?v=e35f923a',
    },
    'tile-red': {
      x1: '/art/roulette/tile-red.webp?v=1fa67954',
      x2: '/art/roulette/tile-red@2x.webp?v=572abec3',
    },
    'tile-black': {
      x1: '/art/roulette/tile-black.webp?v=5e87282a',
      x2: '/art/roulette/tile-black@2x.webp?v=7f2d3016',
    },
    'tile-green': {
      x1: '/art/roulette/tile-green.webp?v=77dc446b',
      x2: '/art/roulette/tile-green@2x.webp?v=1d2086e7',
    },
  },
  carp: {
    carp: {
      x1: '/art/carp/carp.webp?v=f7ba93e3',
      x2: '/art/carp/carp@2x.webp?v=b0363c3f',
    },
    dragon: {
      x1: '/art/carp/dragon.webp?v=cc777cd0',
      x2: '/art/carp/dragon@2x.webp?v=47ffc457',
    },
    gate: {
      x1: '/art/carp/gate.webp?v=00359ced',
      x2: '/art/carp/gate@2x.webp?v=d3f0d0ab',
    },
    ledge: {
      x1: '/art/carp/ledge.webp?v=4a02451b',
      x2: '/art/carp/ledge@2x.webp?v=275b43cd',
    },
    'ledge-broken': {
      x1: '/art/carp/ledge-broken.webp?v=f536d070',
      x2: '/art/carp/ledge-broken@2x.webp?v=49486990',
    },
    rock: {
      x1: '/art/carp/rock.webp?v=2f322888',
      x2: '/art/carp/rock@2x.webp?v=adf8b517',
    },
  },
  firecrackers: {
    envelope: {
      x1: '/art/firecrackers/envelope.webp?v=fd1f402a',
      x2: '/art/firecrackers/envelope@2x.webp?v=9589f426',
    },
    open: {
      x1: '/art/firecrackers/open.webp?v=08b61ca4',
      x2: '/art/firecrackers/open@2x.webp?v=f81833cd',
    },
    ingot: {
      x1: '/art/firecrackers/ingot.webp?v=3cc48e26',
      x2: '/art/firecrackers/ingot@2x.webp?v=c483a85d',
    },
    firecracker: {
      x1: '/art/firecrackers/firecracker.webp?v=326d1489',
      x2: '/art/firecrackers/firecracker@2x.webp?v=e913edec',
    },
    sparks: {
      x1: '/art/firecrackers/sparks.webp?v=4f32b6c2',
      x2: '/art/firecrackers/sparks@2x.webp?v=a1b55b7c',
    },
  },
  hongbao: {
    seat: {
      x1: '/art/hongbao/seat.webp?v=7cf7a261',
      x2: '/art/hongbao/seat@2x.webp?v=5a43ad3d',
    },
    crown: {
      x1: '/art/hongbao/crown.webp?v=179f9cf6',
      x2: '/art/hongbao/crown@2x.webp?v=9e1aaf9c',
    },
    envelope: {
      x1: '/art/hongbao/envelope.webp?v=4a2a51af',
      x2: '/art/hongbao/envelope@2x.webp?v=23996ac6',
    },
  },
  mahjong: {
    'tile-back': {
      x1: '/art/mahjong/tile-back.webp?v=0c18c51e',
      x2: '/art/mahjong/tile-back@2x.webp?v=fe7fdc97',
    },
    'tile-face': {
      x1: '/art/mahjong/tile-face.webp?v=3d1cc667',
      x2: '/art/mahjong/tile-face@2x.webp?v=8d974816',
    },
  },
  chess: {
    'classic-wK': {
      x1: '/art/chess/classic-wK.webp?v=adef5d35',
      x2: '/art/chess/classic-wK@2x.webp?v=f3d8b26b',
    },
    'classic-wQ': {
      x1: '/art/chess/classic-wQ.webp?v=cbb71538',
      x2: '/art/chess/classic-wQ@2x.webp?v=f1dbd7b2',
    },
    'classic-wR': {
      x1: '/art/chess/classic-wR.webp?v=d2eeb7d3',
      x2: '/art/chess/classic-wR@2x.webp?v=3295b44b',
    },
    'classic-wB': {
      x1: '/art/chess/classic-wB.webp?v=00fbb786',
      x2: '/art/chess/classic-wB@2x.webp?v=33fc22d6',
    },
    'classic-wN': {
      x1: '/art/chess/classic-wN.webp?v=5562a7b9',
      x2: '/art/chess/classic-wN@2x.webp?v=8550999b',
    },
    'classic-wp': {
      x1: '/art/chess/classic-wp.webp?v=78cab6a7',
      x2: '/art/chess/classic-wp@2x.webp?v=d4332610',
    },
    'classic-bK': {
      x1: '/art/chess/classic-bK.webp?v=92fb8c07',
      x2: '/art/chess/classic-bK@2x.webp?v=b08f44e4',
    },
    'classic-bQ': {
      x1: '/art/chess/classic-bQ.webp?v=1b4ad8b9',
      x2: '/art/chess/classic-bQ@2x.webp?v=0cbdbd84',
    },
    'classic-bR': {
      x1: '/art/chess/classic-bR.webp?v=7957f2e5',
      x2: '/art/chess/classic-bR@2x.webp?v=18722e0c',
    },
    'classic-bB': {
      x1: '/art/chess/classic-bB.webp?v=4dae1262',
      x2: '/art/chess/classic-bB@2x.webp?v=1811a58c',
    },
    'classic-bN': {
      x1: '/art/chess/classic-bN.webp?v=83ea95b9',
      x2: '/art/chess/classic-bN@2x.webp?v=8363cc1d',
    },
    'classic-bp': {
      x1: '/art/chess/classic-bp.webp?v=3c2565de',
      x2: '/art/chess/classic-bp@2x.webp?v=a8aea9f8',
    },
    'modern-wK': {
      x1: '/art/chess/modern-wK.webp?v=6b076785',
      x2: '/art/chess/modern-wK@2x.webp?v=18358d5e',
    },
    'modern-wQ': {
      x1: '/art/chess/modern-wQ.webp?v=5241db0d',
      x2: '/art/chess/modern-wQ@2x.webp?v=d34fa9e5',
    },
    'modern-wR': {
      x1: '/art/chess/modern-wR.webp?v=b6c8b161',
      x2: '/art/chess/modern-wR@2x.webp?v=0e220c90',
    },
    'modern-wB': {
      x1: '/art/chess/modern-wB.webp?v=2fa6a28e',
      x2: '/art/chess/modern-wB@2x.webp?v=aa20f4fc',
    },
    'modern-wN': {
      x1: '/art/chess/modern-wN.webp?v=f0daa544',
      x2: '/art/chess/modern-wN@2x.webp?v=d474bd70',
    },
    'modern-wp': {
      x1: '/art/chess/modern-wp.webp?v=8daeeb5f',
      x2: '/art/chess/modern-wp@2x.webp?v=1bc6a901',
    },
    'modern-bK': {
      x1: '/art/chess/modern-bK.webp?v=89b10807',
      x2: '/art/chess/modern-bK@2x.webp?v=690e0e5b',
    },
    'modern-bQ': {
      x1: '/art/chess/modern-bQ.webp?v=d324e7b9',
      x2: '/art/chess/modern-bQ@2x.webp?v=794dfaff',
    },
    'modern-bR': {
      x1: '/art/chess/modern-bR.webp?v=f66edbbf',
      x2: '/art/chess/modern-bR@2x.webp?v=5fecc419',
    },
    'modern-bB': {
      x1: '/art/chess/modern-bB.webp?v=8885c404',
      x2: '/art/chess/modern-bB@2x.webp?v=069d4af0',
    },
    'modern-bN': {
      x1: '/art/chess/modern-bN.webp?v=f21e17b9',
      x2: '/art/chess/modern-bN@2x.webp?v=5c3e4475',
    },
    'modern-bp': {
      x1: '/art/chess/modern-bp.webp?v=abe415cf',
      x2: '/art/chess/modern-bp@2x.webp?v=6d723e83',
    },
  },
  'color-sort': {
    'chip-0': {
      x1: '/art/color-sort/chip-0.webp?v=140d9c8d',
      x2: '/art/color-sort/chip-0@2x.webp?v=cb2e2423',
    },
    'chip-1': {
      x1: '/art/color-sort/chip-1.webp?v=910a5d1b',
      x2: '/art/color-sort/chip-1@2x.webp?v=38b5795d',
    },
    'chip-2': {
      x1: '/art/color-sort/chip-2.webp?v=875fbc00',
      x2: '/art/color-sort/chip-2@2x.webp?v=8c0c0d6b',
    },
    'chip-3': {
      x1: '/art/color-sort/chip-3.webp?v=e7b9efcc',
      x2: '/art/color-sort/chip-3@2x.webp?v=11451926',
    },
    'chip-4': {
      x1: '/art/color-sort/chip-4.webp?v=93682b37',
      x2: '/art/color-sort/chip-4@2x.webp?v=3d9aa97a',
    },
    'chip-5': {
      x1: '/art/color-sort/chip-5.webp?v=2ca62da2',
      x2: '/art/color-sort/chip-5@2x.webp?v=52a5e7cb',
    },
    'chip-6': {
      x1: '/art/color-sort/chip-6.webp?v=de0878d2',
      x2: '/art/color-sort/chip-6@2x.webp?v=fb7a0f7e',
    },
    'chip-7': {
      x1: '/art/color-sort/chip-7.webp?v=694a5475',
      x2: '/art/color-sort/chip-7@2x.webp?v=f7df4aa9',
    },
    tube: {
      x1: '/art/color-sort/tube.webp?v=5a89f0e4',
      x2: '/art/color-sort/tube@2x.webp?v=eaf5836d',
    },
  },
  'lucky-lever': {
    peach: {
      x1: '/art/lucky-lever/peach.webp?v=9ae6fc0c',
      x2: '/art/lucky-lever/peach@2x.webp?v=6d9445f8',
    },
    gourd: {
      x1: '/art/lucky-lever/gourd.webp?v=b3a1e370',
      x2: '/art/lucky-lever/gourd@2x.webp?v=9231573f',
    },
    lantern: {
      x1: '/art/lucky-lever/lantern.webp?v=baba65d1',
      x2: '/art/lucky-lever/lantern@2x.webp?v=eb9da7ee',
    },
    koi: {
      x1: '/art/lucky-lever/koi.webp?v=f8f15ead',
      x2: '/art/lucky-lever/koi@2x.webp?v=7181c720',
    },
    ingot: {
      x1: '/art/lucky-lever/ingot.webp?v=1d094f25',
      x2: '/art/lucky-lever/ingot@2x.webp?v=d39354a2',
    },
    jade: {
      x1: '/art/lucky-lever/jade.webp?v=f3c1ff04',
      x2: '/art/lucky-lever/jade@2x.webp?v=c19f7f5d',
    },
    dragon: {
      x1: '/art/lucky-lever/dragon.webp?v=27484933',
      x2: '/art/lucky-lever/dragon@2x.webp?v=5dee1f74',
    },
    'lever-arm': {
      x1: '/art/lucky-lever/lever-arm.webp?v=e39438f1',
      x2: '/art/lucky-lever/lever-arm@2x.webp?v=03aede03',
    },
    'lever-knob': {
      x1: '/art/lucky-lever/lever-knob.webp?v=abe65a0f',
      x2: '/art/lucky-lever/lever-knob@2x.webp?v=e6721954',
    },
  },
  'neon-arcade': {
    star: {
      x1: '/art/neon-arcade/star.webp?v=3af9a448',
      x2: '/art/neon-arcade/star@2x.webp?v=6239996c',
    },
    flipper: {
      x1: '/art/neon-arcade/flipper.webp?v=ae17c223',
      x2: '/art/neon-arcade/flipper@2x.webp?v=cb9ce178',
    },
    cassette: {
      x1: '/art/neon-arcade/cassette.webp?v=f8c60586',
      x2: '/art/neon-arcade/cassette@2x.webp?v=75f84f00',
    },
    joystick: {
      x1: '/art/neon-arcade/joystick.webp?v=6aff5958',
      x2: '/art/neon-arcade/joystick@2x.webp?v=558b3b59',
    },
    crystal: {
      x1: '/art/neon-arcade/crystal.webp?v=16137a6e',
      x2: '/art/neon-arcade/crystal@2x.webp?v=6ffb165f',
    },
    ufo: {
      x1: '/art/neon-arcade/ufo.webp?v=ce38570d',
      x2: '/art/neon-arcade/ufo@2x.webp?v=77c7f2ff',
    },
    bolt: {
      x1: '/art/neon-arcade/bolt.webp?v=5686a45b',
      x2: '/art/neon-arcade/bolt@2x.webp?v=cd88c83c',
    },
    'lever-arm': {
      x1: '/art/neon-arcade/lever-arm.webp?v=2512fdeb',
      x2: '/art/neon-arcade/lever-arm@2x.webp?v=1d344938',
    },
    'lever-knob': {
      x1: '/art/neon-arcade/lever-knob.webp?v=c527cf79',
      x2: '/art/neon-arcade/lever-knob@2x.webp?v=f9126855',
    },
  },
  'pirate-cove': {
    shell: {
      x1: '/art/pirate-cove/shell.webp?v=c68ef673',
      x2: '/art/pirate-cove/shell@2x.webp?v=f145ea72',
    },
    anchor: {
      x1: '/art/pirate-cove/anchor.webp?v=2e6d1a09',
      x2: '/art/pirate-cove/anchor@2x.webp?v=920746b9',
    },
    spyglass: {
      x1: '/art/pirate-cove/spyglass.webp?v=4cc6d334',
      x2: '/art/pirate-cove/spyglass@2x.webp?v=98d7bcab',
    },
    compass: {
      x1: '/art/pirate-cove/compass.webp?v=946d9bf5',
      x2: '/art/pirate-cove/compass@2x.webp?v=d9716b9c',
    },
    parrot: {
      x1: '/art/pirate-cove/parrot.webp?v=35a01650',
      x2: '/art/pirate-cove/parrot@2x.webp?v=796723e2',
    },
    map: {
      x1: '/art/pirate-cove/map.webp?v=c775ff8e',
      x2: '/art/pirate-cove/map@2x.webp?v=326dfc6b',
    },
    chest: {
      x1: '/art/pirate-cove/chest.webp?v=4ee1f245',
      x2: '/art/pirate-cove/chest@2x.webp?v=57a547fd',
    },
    'lever-arm': {
      x1: '/art/pirate-cove/lever-arm.webp?v=24b70ea4',
      x2: '/art/pirate-cove/lever-arm@2x.webp?v=a0574b1d',
    },
    'lever-knob': {
      x1: '/art/pirate-cove/lever-knob.webp?v=e2554ea5',
      x2: '/art/pirate-cove/lever-knob@2x.webp?v=36041dd7',
    },
  },
  cards: {
    'card-back': {
      x1: '/art/cards/card-back.webp?v=791b9d4e',
      x2: '/art/cards/card-back@2x.webp?v=7b3587f3',
    },
    deck: {
      x1: '/art/cards/deck.webp?v=9b9efc9d',
      x2: '/art/cards/deck@2x.webp?v=d3e016b4',
    },
    'landlord-hat': {
      x1: '/art/cards/landlord-hat.webp?v=cf657f06',
      x2: '/art/cards/landlord-hat@2x.webp?v=e4fba4ee',
    },
    'flower-emblem': {
      x1: '/art/cards/flower-emblem.webp?v=19401f2f',
      x2: '/art/cards/flower-emblem@2x.webp?v=d69125c9',
    },
  },
  'koi-ranks': {
    'disc-teal': {
      x1: '/art/koi-ranks/disc-teal.webp?v=7fc49dba',
      x2: '/art/koi-ranks/disc-teal@2x.webp?v=875a3156',
    },
    'disc-sky': {
      x1: '/art/koi-ranks/disc-sky.webp?v=0a6a1c48',
      x2: '/art/koi-ranks/disc-sky@2x.webp?v=324902dc',
    },
    'disc-purple': {
      x1: '/art/koi-ranks/disc-purple.webp?v=fd7ba652',
      x2: '/art/koi-ranks/disc-purple@2x.webp?v=8c7da17a',
    },
  },
  icons: {
    home: {
      x1: '/art/icons/home.webp?v=90b0d379',
      x2: '/art/icons/home@2x.webp?v=731de162',
    },
    messages: {
      x1: '/art/icons/messages.webp?v=922e03fe',
      x2: '/art/icons/messages@2x.webp?v=d63bd0bf',
    },
    machines: {
      x1: '/art/icons/machines.webp?v=c4315a20',
      x2: '/art/icons/machines@2x.webp?v=6d2b1f6d',
    },
    games: {
      x1: '/art/icons/games.webp?v=442f190c',
      x2: '/art/icons/games@2x.webp?v=61a3a819',
    },
    slots: {
      x1: '/art/icons/slots.webp?v=3f4c5ed0',
      x2: '/art/icons/slots@2x.webp?v=dd81cd7a',
    },
    tournaments: {
      x1: '/art/icons/tournaments.webp?v=4f7bca01',
      x2: '/art/icons/tournaments@2x.webp?v=ad1998fa',
    },
    friends: {
      x1: '/art/icons/friends.webp?v=9fe995ee',
      x2: '/art/icons/friends@2x.webp?v=fcbf156b',
    },
    profile: {
      x1: '/art/icons/profile.webp?v=59643634',
      x2: '/art/icons/profile@2x.webp?v=3325bbcf',
    },
    settings: {
      x1: '/art/icons/settings.webp?v=cb12e071',
      x2: '/art/icons/settings@2x.webp?v=7b2978cf',
    },
    'sound-on': {
      x1: '/art/icons/sound-on.webp?v=6be0ef62',
      x2: '/art/icons/sound-on@2x.webp?v=af136915',
    },
    'sound-off': {
      x1: '/art/icons/sound-off.webp?v=50501828',
      x2: '/art/icons/sound-off@2x.webp?v=cdc0423a',
    },
    'music-on': {
      x1: '/art/icons/music-on.webp?v=0844ea32',
      x2: '/art/icons/music-on@2x.webp?v=8f782e5a',
    },
    'music-off': {
      x1: '/art/icons/music-off.webp?v=24362d1a',
      x2: '/art/icons/music-off@2x.webp?v=2e108106',
    },
    info: {
      x1: '/art/icons/info.webp?v=86380622',
      x2: '/art/icons/info@2x.webp?v=ec0c5081',
    },
    paytable: {
      x1: '/art/icons/paytable.webp?v=f3d72ebb',
      x2: '/art/icons/paytable@2x.webp?v=a997aa49',
    },
    autoplay: {
      x1: '/art/icons/autoplay.webp?v=57dbd568',
      x2: '/art/icons/autoplay@2x.webp?v=0f01d5a3',
    },
    back: {
      x1: '/art/icons/back.webp?v=d752e9e2',
      x2: '/art/icons/back@2x.webp?v=c8d03080',
    },
    close: {
      x1: '/art/icons/close.webp?v=15d93ab2',
      x2: '/art/icons/close@2x.webp?v=5549bfd3',
    },
    plus: {
      x1: '/art/icons/plus.webp?v=a9f57908',
      x2: '/art/icons/plus@2x.webp?v=63d115b7',
    },
    minus: {
      x1: '/art/icons/minus.webp?v=9c65d452',
      x2: '/art/icons/minus@2x.webp?v=30ee00bd',
    },
    share: {
      x1: '/art/icons/share.webp?v=5ea6ce82',
      x2: '/art/icons/share@2x.webp?v=51b79bf0',
    },
    history: {
      x1: '/art/icons/history.webp?v=c4341284',
      x2: '/art/icons/history@2x.webp?v=4fefe6b4',
    },
    'fair-shield': {
      x1: '/art/icons/fair-shield.webp?v=4688c6c3',
      x2: '/art/icons/fair-shield@2x.webp?v=4426563a',
    },
    limits: {
      x1: '/art/icons/limits.webp?v=c0a1d28b',
      x2: '/art/icons/limits@2x.webp?v=dc2bd2be',
    },
    gift: {
      x1: '/art/icons/gift.webp?v=01c16e78',
      x2: '/art/icons/gift@2x.webp?v=3eff4e24',
    },
    trophy: {
      x1: '/art/icons/trophy.webp?v=96cc040c',
      x2: '/art/icons/trophy@2x.webp?v=4e10cc42',
    },
    bell: {
      x1: '/art/icons/bell.webp?v=61bcb11c',
      x2: '/art/icons/bell@2x.webp?v=740602b9',
    },
    search: {
      x1: '/art/icons/search.webp?v=5775efb6',
      x2: '/art/icons/search@2x.webp?v=8258b228',
    },
    logout: {
      x1: '/art/icons/logout.webp?v=5f705f21',
      x2: '/art/icons/logout@2x.webp?v=69df6fcd',
    },
    language: {
      x1: '/art/icons/language.webp?v=6a1b8820',
      x2: '/art/icons/language@2x.webp?v=08225ffc',
    },
    theme: {
      x1: '/art/icons/theme.webp?v=efee94d9',
      x2: '/art/icons/theme@2x.webp?v=1ca5c525',
    },
    coin: {
      x1: '/art/icons/coin.webp?v=10d76b03',
      x2: '/art/icons/coin@2x.webp?v=d252bef8',
    },
    'friends-small': {
      x1: '/art/icons/friends-small.webp?v=42841ba2',
      x2: '/art/icons/friends-small@2x.webp?v=52f45493',
    },
    'profile-small': {
      x1: '/art/icons/profile-small.webp?v=099d8e67',
      x2: '/art/icons/profile-small@2x.webp?v=d1b4f4be',
    },
    'games-small': {
      x1: '/art/icons/games-small.webp?v=ec15d18b',
      x2: '/art/icons/games-small@2x.webp?v=f3e3be43',
    },
    'autoplay-small': {
      x1: '/art/icons/autoplay-small.webp?v=2aca6393',
      x2: '/art/icons/autoplay-small@2x.webp?v=0734dafa',
    },
    'history-small': {
      x1: '/art/icons/history-small.webp?v=7d1ec796',
      x2: '/art/icons/history-small@2x.webp?v=b6177fbc',
    },
    'logout-small': {
      x1: '/art/icons/logout-small.webp?v=0f905bd8',
      x2: '/art/icons/logout-small@2x.webp?v=4cbfc62c',
    },
    'theme-small': {
      x1: '/art/icons/theme-small.webp?v=b3003d36',
      x2: '/art/icons/theme-small@2x.webp?v=b4dc6db3',
    },
    'messages-small': {
      x1: '/art/icons/messages-small.webp?v=91cea38f',
      x2: '/art/icons/messages-small@2x.webp?v=8ff36b7a',
    },
    'machines-small': {
      x1: '/art/icons/machines-small.webp?v=33b99f40',
      x2: '/art/icons/machines-small@2x.webp?v=b920817e',
    },
  },
  passport: {
    stamp: {
      x1: '/art/passport/stamp.webp?v=c012858d',
      x2: '/art/passport/stamp@2x.webp?v=b210bb59',
    },
  },
  emblems: {
    quest: {
      x1: '/art/emblems/quest.webp?v=65bc2d43',
      x2: '/art/emblems/quest@2x.webp?v=718f6d72',
    },
    jackpot: {
      x1: '/art/emblems/jackpot.webp?v=daf8380c',
      x2: '/art/emblems/jackpot@2x.webp?v=c68ebee9',
    },
  },
};

export const RASTER_BG: {
  readonly [G in keyof RasterBgKeys]?: Partial<
    Record<RasterBgKeys[G], Partial<Record<RasterTheme, RasterImage>>>
  >;
} = {
  crash: {
    sky: {
      dark: {
        x1: '/art/crash/sky-dark.webp?v=69f5cebb',
        x2: '/art/crash/sky-dark@2x.webp?v=2d825c65',
      },
      light: {
        x1: '/art/crash/sky-light.webp?v=40192003',
        x2: '/art/crash/sky-light@2x.webp?v=23932220',
      },
    },
    scene: {
      dark: {
        x1: '/art/crash/scene-dark.webp?v=ee47e288',
        x2: '/art/crash/scene-dark@2x.webp?v=10684041',
      },
      light: {
        x1: '/art/crash/scene-light.webp?v=bbd122ac',
        x2: '/art/crash/scene-light@2x.webp?v=817b6ac3',
      },
    },
  },
  pot: {
    stage: {
      dark: {
        x1: '/art/pot/stage-dark.webp?v=fa60f03c',
        x2: '/art/pot/stage-dark@2x.webp?v=4bc58f71',
      },
      light: {
        x1: '/art/pot/stage-light.webp?v=769918b7',
        x2: '/art/pot/stage-light@2x.webp?v=bd1a6108',
      },
    },
    scene: {
      dark: {
        x1: '/art/pot/scene-dark.webp?v=6d74ddcf',
        x2: '/art/pot/scene-dark@2x.webp?v=fb099a96',
      },
      light: {
        x1: '/art/pot/scene-light.webp?v=6a197091',
        x2: '/art/pot/scene-light@2x.webp?v=21779309',
      },
    },
  },
  roulette: {
    stage: {
      dark: {
        x1: '/art/roulette/stage-dark.webp?v=2f930c1b',
        x2: '/art/roulette/stage-dark@2x.webp?v=ca5affce',
      },
      light: {
        x1: '/art/roulette/stage-light.webp?v=a809d66a',
        x2: '/art/roulette/stage-light@2x.webp?v=1d5288e6',
      },
    },
    scene: {
      dark: {
        x1: '/art/roulette/scene-dark.webp?v=5d50dc46',
        x2: '/art/roulette/scene-dark@2x.webp?v=a7b77eb9',
      },
      light: {
        x1: '/art/roulette/scene-light.webp?v=2b40ac81',
        x2: '/art/roulette/scene-light@2x.webp?v=f94fd1fa',
      },
    },
  },
  carp: {
    fall: {
      dark: {
        x1: '/art/carp/fall-dark.webp?v=9ee2579c',
        x2: '/art/carp/fall-dark@2x.webp?v=ba3da4e1',
      },
      light: {
        x1: '/art/carp/fall-light.webp?v=ce261894',
        x2: '/art/carp/fall-light@2x.webp?v=51354b00',
      },
    },
    scene: {
      dark: {
        x1: '/art/carp/scene-dark.webp?v=b9a0715b',
        x2: '/art/carp/scene-dark@2x.webp?v=7fe88aa5',
      },
      light: {
        x1: '/art/carp/scene-light.webp?v=7068953d',
        x2: '/art/carp/scene-light@2x.webp?v=4494b6a5',
      },
    },
  },
  firecrackers: {
    board: {
      dark: {
        x1: '/art/firecrackers/board-dark.webp?v=ec1bbdfe',
        x2: '/art/firecrackers/board-dark@2x.webp?v=f38a5160',
      },
      light: {
        x1: '/art/firecrackers/board-light.webp?v=767a1a4c',
        x2: '/art/firecrackers/board-light@2x.webp?v=0b0bd78f',
      },
    },
    scene: {
      dark: {
        x1: '/art/firecrackers/scene-dark.webp?v=c241abb5',
        x2: '/art/firecrackers/scene-dark@2x.webp?v=7b916e51',
      },
      light: {
        x1: '/art/firecrackers/scene-light.webp?v=dc51e30e',
        x2: '/art/firecrackers/scene-light@2x.webp?v=fb5c11bf',
      },
    },
  },
  hongbao: {
    table: {
      dark: {
        x1: '/art/hongbao/table-dark.webp?v=836524bc',
        x2: '/art/hongbao/table-dark@2x.webp?v=fbd7dc52',
      },
      light: {
        x1: '/art/hongbao/table-light.webp?v=2a09daf3',
        x2: '/art/hongbao/table-light@2x.webp?v=76a88e57',
      },
    },
    scene: {
      dark: {
        x1: '/art/hongbao/scene-dark.webp?v=c9afd0c4',
        x2: '/art/hongbao/scene-dark@2x.webp?v=8b56afed',
      },
      light: {
        x1: '/art/hongbao/scene-light.webp?v=63e9bd44',
        x2: '/art/hongbao/scene-light@2x.webp?v=c01c764d',
      },
    },
  },
  mahjong: {
    felt: {
      dark: {
        x1: '/art/mahjong/felt-dark.webp?v=3447c0aa',
        x2: '/art/mahjong/felt-dark@2x.webp?v=c932def2',
      },
      light: {
        x1: '/art/mahjong/felt-light.webp?v=27f8c2e7',
        x2: '/art/mahjong/felt-light@2x.webp?v=9bfc949a',
      },
    },
    scene: {
      dark: {
        x1: '/art/mahjong/scene-dark.webp?v=3fe3d0b0',
        x2: '/art/mahjong/scene-dark@2x.webp?v=68423429',
      },
      light: {
        x1: '/art/mahjong/scene-light.webp?v=940ecf09',
        x2: '/art/mahjong/scene-light@2x.webp?v=9ad21b89',
      },
    },
  },
  'mahjong-table': {
    scene: {
      dark: {
        x1: '/art/mahjong-table/scene-dark.webp?v=3911d112',
        x2: '/art/mahjong-table/scene-dark@2x.webp?v=3fd09f03',
      },
      light: {
        x1: '/art/mahjong-table/scene-light.webp?v=3e6bdd52',
        x2: '/art/mahjong-table/scene-light@2x.webp?v=871c1911',
      },
    },
  },
  'tile-match': {
    scene: {
      dark: {
        x1: '/art/tile-match/scene-dark.webp?v=9a62d484',
        x2: '/art/tile-match/scene-dark@2x.webp?v=13e458ab',
      },
      light: {
        x1: '/art/tile-match/scene-light.webp?v=bcd11cd0',
        x2: '/art/tile-match/scene-light@2x.webp?v=4fafbf01',
      },
    },
  },
  chess: {
    scene: {
      dark: {
        x1: '/art/chess/scene-dark.webp?v=be5586f2',
        x2: '/art/chess/scene-dark@2x.webp?v=37b37290',
      },
      light: {
        x1: '/art/chess/scene-light.webp?v=2d507ad3',
        x2: '/art/chess/scene-light@2x.webp?v=3a1ebc6d',
      },
    },
  },
  'daily-words': {
    scene: {
      dark: {
        x1: '/art/daily-words/scene-dark.webp?v=3c220670',
        x2: '/art/daily-words/scene-dark@2x.webp?v=dc7cefa0',
      },
      light: {
        x1: '/art/daily-words/scene-light.webp?v=0c4e8cef',
        x2: '/art/daily-words/scene-light@2x.webp?v=ff8fbdc1',
      },
    },
  },
  'color-sort': {
    scene: {
      dark: {
        x1: '/art/color-sort/scene-dark.webp?v=efd474d4',
        x2: '/art/color-sort/scene-dark@2x.webp?v=f38ec0a4',
      },
      light: {
        x1: '/art/color-sort/scene-light.webp?v=37abbd1e',
        x2: '/art/color-sort/scene-light@2x.webp?v=13a8bab3',
      },
    },
  },
  'lucky-lever': {
    cabinet: {
      dark: {
        x1: '/art/lucky-lever/cabinet-dark.webp?v=4d61f9a7',
        x2: '/art/lucky-lever/cabinet-dark@2x.webp?v=f71ed51a',
      },
      light: {
        x1: '/art/lucky-lever/cabinet-light.webp?v=0cbe205a',
        x2: '/art/lucky-lever/cabinet-light@2x.webp?v=2e21dbc9',
      },
    },
    scene: {
      dark: {
        x1: '/art/lucky-lever/scene-dark.webp?v=1ce41159',
        x2: '/art/lucky-lever/scene-dark@2x.webp?v=b9ecb936',
      },
      light: {
        x1: '/art/lucky-lever/scene-light.webp?v=08fb67d6',
        x2: '/art/lucky-lever/scene-light@2x.webp?v=834b2ce1',
      },
    },
  },
  'neon-arcade': {
    cabinet: {
      dark: {
        x1: '/art/neon-arcade/cabinet-dark.webp?v=3f0a4cd6',
        x2: '/art/neon-arcade/cabinet-dark@2x.webp?v=cf4facd6',
      },
      light: {
        x1: '/art/neon-arcade/cabinet-light.webp?v=b98a1cd6',
        x2: '/art/neon-arcade/cabinet-light@2x.webp?v=650101f3',
      },
    },
    scene: {
      dark: {
        x1: '/art/neon-arcade/scene-dark.webp?v=2247f6c7',
        x2: '/art/neon-arcade/scene-dark@2x.webp?v=b8e63a97',
      },
      light: {
        x1: '/art/neon-arcade/scene-light.webp?v=ceb2a4bc',
        x2: '/art/neon-arcade/scene-light@2x.webp?v=edcc0e47',
      },
    },
  },
  'pirate-cove': {
    cabinet: {
      dark: {
        x1: '/art/pirate-cove/cabinet-dark.webp?v=baf97c48',
        x2: '/art/pirate-cove/cabinet-dark@2x.webp?v=033d7c1c',
      },
      light: {
        x1: '/art/pirate-cove/cabinet-light.webp?v=ce153791',
        x2: '/art/pirate-cove/cabinet-light@2x.webp?v=277baab2',
      },
    },
    scene: {
      dark: {
        x1: '/art/pirate-cove/scene-dark.webp?v=bd0c8278',
        x2: '/art/pirate-cove/scene-dark@2x.webp?v=3acd4899',
      },
      light: {
        x1: '/art/pirate-cove/scene-light.webp?v=03b91947',
        x2: '/art/pirate-cove/scene-light@2x.webp?v=d3954101',
      },
    },
  },
  zhajinhua: {
    scene: {
      dark: {
        x1: '/art/zhajinhua/scene-dark.webp?v=2303e163',
        x2: '/art/zhajinhua/scene-dark@2x.webp?v=5089a0e4',
      },
      light: {
        x1: '/art/zhajinhua/scene-light.webp?v=69020e1a',
        x2: '/art/zhajinhua/scene-light@2x.webp?v=f94f3e3a',
      },
    },
  },
  doudizhu: {
    scene: {
      dark: {
        x1: '/art/doudizhu/scene-dark.webp?v=f14ce5a0',
        x2: '/art/doudizhu/scene-dark@2x.webp?v=2b8f816b',
      },
      light: {
        x1: '/art/doudizhu/scene-light.webp?v=28b60362',
        x2: '/art/doudizhu/scene-light@2x.webp?v=8e157fa5',
      },
    },
  },
  cards: {
    table: {
      dark: {
        x1: '/art/cards/table-dark.webp?v=2a684488',
        x2: '/art/cards/table-dark@2x.webp?v=fe923c95',
      },
      light: {
        x1: '/art/cards/table-light.webp?v=800a1a8e',
        x2: '/art/cards/table-light@2x.webp?v=81e24979',
      },
    },
  },
  passport: {
    cover: {
      dark: {
        x1: '/art/passport/cover-dark.webp?v=a194be3e',
        x2: '/art/passport/cover-dark@2x.webp?v=9b530fc5',
      },
      light: {
        x1: '/art/passport/cover-light.webp?v=728aefa0',
        x2: '/art/passport/cover-light@2x.webp?v=67cb54e7',
      },
    },
  },
  ui: {
    'reels-frame-garden': {
      dark: {
        x1: '/art/ui/reels-frame-garden-dark.webp?v=a6604d57',
        x2: '/art/ui/reels-frame-garden-dark@2x.webp?v=9a713d3f',
      },
      light: {
        x1: '/art/ui/reels-frame-garden-light.webp?v=10db6f3f',
        x2: '/art/ui/reels-frame-garden-light@2x.webp?v=89627af5',
      },
    },
    'reels-frame-deep': {
      dark: {
        x1: '/art/ui/reels-frame-deep-dark.webp?v=9fb5d4c0',
        x2: '/art/ui/reels-frame-deep-dark@2x.webp?v=d12a7aa9',
      },
      light: {
        x1: '/art/ui/reels-frame-deep-light.webp?v=b12b1399',
        x2: '/art/ui/reels-frame-deep-light@2x.webp?v=e31186d1',
      },
    },
    'reels-frame-spaceport': {
      dark: {
        x1: '/art/ui/reels-frame-spaceport-dark.webp?v=1d175b1a',
        x2: '/art/ui/reels-frame-spaceport-dark@2x.webp?v=55df9106',
      },
      light: {
        x1: '/art/ui/reels-frame-spaceport-light.webp?v=8652a7fb',
        x2: '/art/ui/reels-frame-spaceport-light@2x.webp?v=b0733960',
      },
    },
    'reels-frame-sweet-shop': {
      dark: {
        x1: '/art/ui/reels-frame-sweet-shop-dark.webp?v=9832256a',
        x2: '/art/ui/reels-frame-sweet-shop-dark@2x.webp?v=a220f555',
      },
      light: {
        x1: '/art/ui/reels-frame-sweet-shop-light.webp?v=19111c26',
        x2: '/art/ui/reels-frame-sweet-shop-light@2x.webp?v=3bd37733',
      },
    },
    'reels-frame-workshop': {
      dark: {
        x1: '/art/ui/reels-frame-workshop-dark.webp?v=b546cef7',
        x2: '/art/ui/reels-frame-workshop-dark@2x.webp?v=2124b30a',
      },
      light: {
        x1: '/art/ui/reels-frame-workshop-light.webp?v=40e0a5be',
        x2: '/art/ui/reels-frame-workshop-light@2x.webp?v=890b7535',
      },
    },
    'reels-frame-koi-pond': {
      dark: {
        x1: '/art/ui/reels-frame-koi-pond-dark.webp?v=12e49b5f',
        x2: '/art/ui/reels-frame-koi-pond-dark@2x.webp?v=d2139261',
      },
      light: {
        x1: '/art/ui/reels-frame-koi-pond-light.webp?v=7e681b43',
        x2: '/art/ui/reels-frame-koi-pond-light@2x.webp?v=1ba8f1fd',
      },
    },
    'jackpot-plate-mini': {
      dark: {
        x1: '/art/ui/jackpot-plate-mini-dark.webp?v=7f12559b',
        x2: '/art/ui/jackpot-plate-mini-dark@2x.webp?v=1702d02c',
      },
      light: {
        x1: '/art/ui/jackpot-plate-mini-light.webp?v=4dfb7395',
        x2: '/art/ui/jackpot-plate-mini-light@2x.webp?v=fc1448fe',
      },
    },
    'jackpot-plate-major': {
      dark: {
        x1: '/art/ui/jackpot-plate-major-dark.webp?v=a512687c',
        x2: '/art/ui/jackpot-plate-major-dark@2x.webp?v=23c11bba',
      },
      light: {
        x1: '/art/ui/jackpot-plate-major-light.webp?v=fabec4d4',
        x2: '/art/ui/jackpot-plate-major-light@2x.webp?v=24328106',
      },
    },
    'jackpot-plate-grand': {
      dark: {
        x1: '/art/ui/jackpot-plate-grand-dark.webp?v=22503ba7',
        x2: '/art/ui/jackpot-plate-grand-dark@2x.webp?v=1065784b',
      },
      light: {
        x1: '/art/ui/jackpot-plate-grand-light.webp?v=10487033',
        x2: '/art/ui/jackpot-plate-grand-light@2x.webp?v=e2c76759',
      },
    },
    'win-plate': {
      dark: {
        x1: '/art/ui/win-plate-dark.webp?v=14c36e18',
        x2: '/art/ui/win-plate-dark@2x.webp?v=b3622173',
      },
      light: {
        x1: '/art/ui/win-plate-light.webp?v=c9887b02',
        x2: '/art/ui/win-plate-light@2x.webp?v=a995dd5e',
      },
    },
    'badge-hot': {
      dark: {
        x1: '/art/ui/badge-hot-dark.webp?v=a6c47b83',
        x2: '/art/ui/badge-hot-dark@2x.webp?v=3cc13b2d',
      },
      light: {
        x1: '/art/ui/badge-hot-light.webp?v=61344150',
        x2: '/art/ui/badge-hot-light@2x.webp?v=0b2e8bf3',
      },
    },
    'badge-new': {
      dark: {
        x1: '/art/ui/badge-new-dark.webp?v=2d54f4f3',
        x2: '/art/ui/badge-new-dark@2x.webp?v=a5a67a13',
      },
      light: {
        x1: '/art/ui/badge-new-light.webp?v=ebd5c85e',
        x2: '/art/ui/badge-new-light@2x.webp?v=b350b1d2',
      },
    },
  },
};

/** 9-slice of UI pieces (only present ones): border in px of the @2x image and its size. */
export interface RasterSlice {
  readonly slice: number;
  readonly width: number;
  readonly height: number;
}

export const RASTER_SLICE: {
  readonly [G in keyof RasterBgKeys]?: Partial<Record<RasterBgKeys[G], RasterSlice>>;
} = {
  'lucky-lever': {
    cabinet: {
      slice: 160,
      width: 1024,
      height: 1024,
    },
  },
  'neon-arcade': {
    cabinet: {
      slice: 160,
      width: 1024,
      height: 1024,
    },
  },
  'pirate-cove': {
    cabinet: {
      slice: 160,
      width: 1024,
      height: 1024,
    },
  },
  ui: {
    'reels-frame-garden': {
      slice: 160,
      width: 1024,
      height: 1024,
    },
    'reels-frame-deep': {
      slice: 160,
      width: 1024,
      height: 1024,
    },
    'reels-frame-spaceport': {
      slice: 160,
      width: 1024,
      height: 1024,
    },
    'reels-frame-sweet-shop': {
      slice: 160,
      width: 1024,
      height: 1024,
    },
    'reels-frame-workshop': {
      slice: 160,
      width: 1024,
      height: 1024,
    },
    'reels-frame-koi-pond': {
      slice: 160,
      width: 1024,
      height: 1024,
    },
    'jackpot-plate-mini': {
      slice: 48,
      width: 512,
      height: 160,
    },
    'jackpot-plate-major': {
      slice: 48,
      width: 512,
      height: 160,
    },
    'jackpot-plate-grand': {
      slice: 48,
      width: 512,
      height: 160,
    },
    'win-plate': {
      slice: 128,
      width: 1024,
      height: 384,
    },
  },
};
